export class AddCardFormSubmit {
    constructor(optionalOptions = {}) {
        this._forms = document.querySelectorAll('form.payment--add-card');
        if (!this._forms) {
            this.destructor();
            return true;
        }

        for (let i = 0; i < this._forms.length; ++i) {
            let form = this._forms[i];
            let template = document.querySelector('.payment-screen-payment-method--template .payment-screen-payment-method--block')
            let wrapSelectors = document.querySelector('.payment-screen-payment-method--selected')
            let id;
            let clonned;
            let inputRadio;
            let wrapBlock;
            let inputCardNum;

            form.addEventListener("submit", (e) => {
                e.preventDefault();

                setTimeout(() => {
                    window.showModal('modal-payment-add-card-success')

                    id = Math.random().toString(36).substring(2, 15);

                    clonned = template.cloneNode(true);
                    clonned.setAttribute('for', id)

                    inputCardNum = form.querySelector('[name="card-num"]').value;
                    clonned.querySelector('.payment-screen-payment-method--code').innerHTML = '<span>··</span> ' + inputCardNum.substring(inputCardNum.length - 4);

                    inputRadio = document.createElement("input")
                    inputRadio.setAttribute('id', id)
                    inputRadio.setAttribute('type', 'radio')
                    inputRadio.setAttribute('name', "payment-card")
                    inputRadio.setAttribute('value', id)
                    inputRadio.setAttribute('class', 'payment-radio')

                    wrapBlock = document.createElement("div")

                    wrapBlock.append(inputRadio)
                    wrapBlock.append(clonned)

                    wrapSelectors.append(wrapBlock)

                    setTimeout(() => {
                        window.closeAllModals()
                        window.closeSheet();
                    }, 2000);

                }, 200);
            })
        }
    }

    destructor() {
        this._forms = null;
    }
}

export default new AddCardFormSubmit();